import template from './workers.html';
import controller from './workers.controller';

let workersComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default workersComponent;
